import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const NewCommentInput = (props) => {
  const [isExpanded, setIsExpanded] = useState(!props.initiallyCollapsed);
  const [newCommentContent, setNewCommentContent] = useState('');

  const submitNewComment = async () => {
    const content = newCommentContent.trim();

    if (!content) {
      return;
    }

    try {
      await axios.post(`/ajax/audio/${props.audioId}/comments`, {
        content,
        parent_comment_id: props.commentId,
      });
      setNewCommentContent('');
      if (props.initiallyCollapsed) {
        setIsExpanded(false);
      }
      await props.newCommentSubmitHandler();
    } catch {
      // Keep textarea content on failed submit so the user can retry.
    }
  };

  const keyDownNewCommentHandler = (event) => {
    if (event.key !== 'Enter' || event.shiftKey) {
      return;
    }
    event.preventDefault();
    submitNewComment();
  };

  return (
    <div className="new-comment-wrapper d-flex align-items-start">
      {isExpanded ? (
        <>
          <div className="comment-avatar flex-shrink-0">
            <img className="img-fluid rounded-circle mx-auto" src={props.loggedProfilePictureUrl} width="64" height="64" alt="" />
          </div>
          <div className="comment-content-wrapper flex-grow-1 ms-2 d-flex align-items-end">
            <textarea
              className="form-control resize-none flex-grow-1"
              rows="3"
              placeholder={props.placeholder || "Write a comment"}
              value={newCommentContent}
              onChange={(event) => setNewCommentContent(event.target.value)}
              onKeyDown={keyDownNewCommentHandler}
            />
            <button
              type="button"
              className="btn btn-link text-decoration-none text-body px-1 py-0 ms-2"
              onClick={submitNewComment}
              >
              <i className="icon-paper-plane fs-5"></i>
            </button>
          </div>
        </>
      ) : (
        <button
          type="button"
          className="btn btn-link text-decoration-none text-body p-0"
          onClick={() => setIsExpanded(true)}
        >
          <i className="icon-mail-reply"></i> Reply
        </button>
      )}
    </div>
  );
};

NewCommentInput.propTypes = {
  newCommentSubmitHandler: PropTypes.func,
  audioId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initiallyCollapsed: PropTypes.bool,
  loggedProfilePictureUrl: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default NewCommentInput;
